module.exports = __webpack_public_path__ + "img/declared-icon.28c78802.svg";